import React from "react";
import Header from "./header";
import Footer from "./footer";

export default function Layout({ children }) {
  return (
    <>
      <Header />
      <div className="th-hero-wrapper hero-9" id="hero">
        {children}
        <Footer />
      </div>
    </>
  );
};


